import React from "react";

const GetOpHours = ({ operatingHours }) => {
    const getOperatingHours = (days) => {
        const dayOrder = [
            "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
        ];

        // Filter valid days and extract relevant info
        const checkedDays = days.filter(item => item.isChecked && item.time.from && item.time.to)
            .map(item => ({
                day: item.day,
                time: `${item.time.from.slice(0, 5)} to ${item.time.to.slice(0, 5)}`
            }));

        // Group by time
        const timeGroups = {};
        checkedDays.forEach(({ day, time }) => {
            if (!timeGroups[time]) {
                timeGroups[time] = [];
            }
            timeGroups[time].push(day);
        });

        // Helper to format grouped days
        const formatRanges = (dayList) => {
            const sortedDays = dayList.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));
            const ranges = [];
            let temp = [sortedDays[0]];

            for (let i = 1; i < sortedDays.length; i++) {
                const prevIdx = dayOrder.indexOf(sortedDays[i - 1]);
                const currIdx = dayOrder.indexOf(sortedDays[i]);

                if (currIdx === prevIdx + 1) {
                    temp.push(sortedDays[i]);
                } else {
                    ranges.push([...temp]);
                    temp = [sortedDays[i]];
                }
            }

            if (temp.length) ranges.push([...temp]);

            return ranges.map(group => {
                if (group.length === 1) return group[0];
                if (group.length === 2) return `${group[0]} & ${group[1]}`;
                return `${group[0]} to ${group[group.length - 1]}`;
            });
        };

        const results = [];

        for (const [time, dayList] of Object.entries(timeGroups)) {
            const ranges = formatRanges(dayList);
            results.push(`${ranges.join(", ")}: ${time}`);
        }

        return results.join(", ");
    };

    return getOperatingHours(operatingHours);
};



export default GetOpHours;